import { FormPositionSeatField } from './form-position-seat-field';

export class FormPositionDefinition {
  public id: string;
  public positionTitle: string;
  public description: string;
  public questionDescription: string;
  public isRequired: boolean;
  public showCurrentValue: boolean;
  public isReadOnly: boolean;
  public minSeatCount: number;
  public oDataFilters: string[];
  public oDataQuery: string;
  public personIdentifiers: string[];
  public arePeopleSyncedToTeamManager: boolean;
  public seatFields: FormPositionSeatField[];
  public formId: string;

  public static parse(data: Partial<FormPositionDefinition>): FormPositionDefinition {
    if (!data) return null;

    const positionDefinition = new FormPositionDefinition();
    positionDefinition.id = data.id;
    positionDefinition.positionTitle = data.positionTitle;
    positionDefinition.description = data.description;
    positionDefinition.questionDescription = data.questionDescription;
    positionDefinition.isRequired = data.isRequired;
    positionDefinition.showCurrentValue = data.showCurrentValue ?? true;
    positionDefinition.isReadOnly = data.isReadOnly ?? false;
    positionDefinition.minSeatCount = data.minSeatCount;
    positionDefinition.oDataFilters = data.oDataFilters ?? [];
    positionDefinition.oDataQuery = data.oDataQuery;
    positionDefinition.personIdentifiers = data.personIdentifiers ?? [];
    positionDefinition.arePeopleSyncedToTeamManager = data.arePeopleSyncedToTeamManager ?? false;
    positionDefinition.seatFields = data.seatFields ?? [];
    positionDefinition.formId = data.formId;

    return positionDefinition;
  }
}
